// Emergency Card App - Multi-language translations
// 10 languages supported

export const translations = {
  en: {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    
    // App
    appName: 'My EmergencyCard App',
    tagline: 'Your medical info, always accessible',
    price: '$1',
    oneTime: 'one-time',
    
    // Hero
    heroTitle: 'Save a Life. Yours.',
    heroSubtitle: 'Create an emergency medical card that anyone can scan. No app needed to view.',
    getStarted: 'Create Your Card - $1',
    
    // Features
    feature1Title: 'Instant Access',
    feature1Desc: 'QR code shows your medical info instantly',
    feature2Title: 'No App Needed',
    feature2Desc: 'Anyone can scan with their phone camera',
    feature3Title: 'Always Available',
    feature3Desc: 'Save to your phone, works offline',
    
    // Form
    basicInfo: 'Basic Information',
    fullName: 'Full Name',
    fullNamePlaceholder: 'As on ID card',
    dateOfBirth: 'Date of Birth',
    bloodGroup: 'Blood Group',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    
    // Emergency Contacts
    emergencyContacts: 'Emergency Contacts',
    contactName: 'Name',
    relationship: 'Relationship',
    phone: 'Phone',
    primary: 'Primary',
    addContact: 'Add Contact',
    spouse: 'Spouse',
    parent: 'Parent',
    child: 'Child',
    sibling: 'Sibling',
    friend: 'Friend',
    doctor: 'Doctor',
    
    // Medical
    allergies: 'Allergies',
    allergiesSubtitle: 'Drug & food allergies',
    severe: 'Severe',
    moderate: 'Moderate',
    mild: 'Mild',
    lifeThreatening: 'Life-threatening',
    significantReaction: 'Significant reaction',
    minorReaction: 'Minor reaction',
    typeToSearch: 'Type 3+ letters to search...',
    
    medicalConditions: 'Medical Conditions',
    currentMedications: 'Current Medications',
    
    // Additional
    additionalInfo: 'Additional Information',
    doctorName: 'Doctor Name',
    doctorPhone: 'Doctor Phone',
    preferredHospital: 'Preferred Hospital',
    organDonor: 'Organ Donor',
    registeredDonor: 'Registered donor',
    specialInstructions: 'Special Instructions',
    specialInstructionsPlaceholder: 'DNR wishes, religious preferences, etc.',
    
    // Actions
    createCard: 'Create Emergency Card',
    saveToPhone: 'Save QR to Phone',
    shareCode: 'Share QR Code',
    copyKey: 'Copy Edit Key',
    previewCard: 'Preview Card',
    
    // Success
    cardCreated: 'Card Created!',
    saveInstructions: 'Save this QR to your phone. In emergencies, show it to medical staff.',
    iphoneHint: 'On iPhone: Long-press the image → "Add to Photos"',
    saveEditKey: 'Save Your Edit Key!',
    editKeyHint: 'Need this to update your card later.',
    
    // Emergency View
    emergencyMedicalInfo: 'EMERGENCY MEDICAL INFO',
    call: 'Call',
    medicalProvider: 'Medical Provider',
    lastUpdated: 'Last updated',
    securedBy: 'Secured by Emergency Card',
    
    // Footer
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
  },
  
  hi: {
    code: 'hi',
    name: 'हिंदी',
    flag: '🇮🇳',
    
    appName: 'आपातकालीन कार्ड',
    tagline: 'आपकी चिकित्सा जानकारी, हमेशा उपलब्ध',
    price: '₹80',
    oneTime: 'एक बार',
    
    heroTitle: 'एक जीवन बचाएं। आपका।',
    heroSubtitle: 'एक आपातकालीन मेडिकल कार्ड बनाएं जिसे कोई भी स्कैन कर सके।',
    getStarted: 'अपना कार्ड बनाएं - ₹80',
    
    feature1Title: 'तुरंत पहुंच',
    feature1Desc: 'QR कोड तुरंत आपकी जानकारी दिखाता है',
    feature2Title: 'ऐप की जरूरत नहीं',
    feature2Desc: 'कोई भी अपने फोन कैमरे से स्कैन कर सकता है',
    feature3Title: 'हमेशा उपलब्ध',
    feature3Desc: 'फोन में सेव करें, ऑफलाइन काम करता है',
    
    basicInfo: 'बुनियादी जानकारी',
    fullName: 'पूरा नाम',
    fullNamePlaceholder: 'जैसा ID कार्ड पर है',
    dateOfBirth: 'जन्म तिथि',
    bloodGroup: 'रक्त समूह',
    gender: 'लिंग',
    male: 'पुरुष',
    female: 'महिला',
    other: 'अन्य',
    
    emergencyContacts: 'आपातकालीन संपर्क',
    contactName: 'नाम',
    relationship: 'रिश्ता',
    phone: 'फोन',
    primary: 'प्राथमिक',
    addContact: 'संपर्क जोड़ें',
    spouse: 'पति/पत्नी',
    parent: 'माता-पिता',
    child: 'बच्चा',
    sibling: 'भाई-बहन',
    friend: 'मित्र',
    doctor: 'डॉक्टर',
    
    allergies: 'एलर्जी',
    allergiesSubtitle: 'दवा और खाने की एलर्जी',
    severe: 'गंभीर',
    moderate: 'मध्यम',
    mild: 'हल्का',
    lifeThreatening: 'जानलेवा',
    significantReaction: 'महत्वपूर्ण प्रतिक्रिया',
    minorReaction: 'मामूली प्रतिक्रिया',
    typeToSearch: 'खोजने के लिए 3+ अक्षर टाइप करें...',
    
    medicalConditions: 'चिकित्सा स्थितियां',
    currentMedications: 'वर्तमान दवाइयां',
    
    additionalInfo: 'अतिरिक्त जानकारी',
    doctorName: 'डॉक्टर का नाम',
    doctorPhone: 'डॉक्टर का फोन',
    preferredHospital: 'पसंदीदा अस्पताल',
    organDonor: 'अंग दाता',
    registeredDonor: 'पंजीकृत दाता',
    specialInstructions: 'विशेष निर्देश',
    specialInstructionsPlaceholder: 'DNR इच्छाएं, धार्मिक प्राथमिकताएं, आदि',
    
    createCard: 'आपातकालीन कार्ड बनाएं',
    saveToPhone: 'QR फोन में सेव करें',
    shareCode: 'QR कोड शेयर करें',
    copyKey: 'कुंजी कॉपी करें',
    previewCard: 'कार्ड देखें',
    
    cardCreated: 'कार्ड बन गया!',
    saveInstructions: 'इस QR को अपने फोन में सेव करें। आपातकाल में, चिकित्सा स्टाफ को दिखाएं।',
    iphoneHint: 'iPhone पर: इमेज को देर तक दबाएं → "फोटो में जोड़ें"',
    saveEditKey: 'अपनी संपादन कुंजी सेव करें!',
    editKeyHint: 'बाद में कार्ड अपडेट करने के लिए इसकी जरूरत होगी।',
    
    emergencyMedicalInfo: 'आपातकालीन चिकित्सा जानकारी',
    call: 'कॉल करें',
    medicalProvider: 'चिकित्सा प्रदाता',
    lastUpdated: 'अंतिम अपडेट',
    securedBy: 'Emergency Card द्वारा सुरक्षित',
    
    privacyPolicy: 'गोपनीयता नीति',
    termsOfService: 'सेवा की शर्तें',
  },
  
  es: {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
    
    appName: 'Tarjeta de Emergencia',
    tagline: 'Tu información médica, siempre accesible',
    price: '$1',
    oneTime: 'único pago',
    
    heroTitle: 'Salva una Vida. La Tuya.',
    heroSubtitle: 'Crea una tarjeta médica de emergencia que cualquiera pueda escanear.',
    getStarted: 'Crear Tu Tarjeta - $1',
    
    feature1Title: 'Acceso Instantáneo',
    feature1Desc: 'El código QR muestra tu información al instante',
    feature2Title: 'Sin App Necesaria',
    feature2Desc: 'Cualquiera puede escanear con su cámara',
    feature3Title: 'Siempre Disponible',
    feature3Desc: 'Guarda en tu teléfono, funciona sin internet',
    
    basicInfo: 'Información Básica',
    fullName: 'Nombre Completo',
    fullNamePlaceholder: 'Como en tu identificación',
    dateOfBirth: 'Fecha de Nacimiento',
    bloodGroup: 'Grupo Sanguíneo',
    gender: 'Género',
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
    
    emergencyContacts: 'Contactos de Emergencia',
    contactName: 'Nombre',
    relationship: 'Relación',
    phone: 'Teléfono',
    primary: 'Principal',
    addContact: 'Agregar Contacto',
    spouse: 'Cónyuge',
    parent: 'Padre/Madre',
    child: 'Hijo/a',
    sibling: 'Hermano/a',
    friend: 'Amigo/a',
    doctor: 'Doctor',
    
    allergies: 'Alergias',
    allergiesSubtitle: 'Alergias a medicamentos y alimentos',
    severe: 'Grave',
    moderate: 'Moderada',
    mild: 'Leve',
    lifeThreatening: 'Potencialmente mortal',
    significantReaction: 'Reacción significativa',
    minorReaction: 'Reacción menor',
    typeToSearch: 'Escribe 3+ letras para buscar...',
    
    medicalConditions: 'Condiciones Médicas',
    currentMedications: 'Medicamentos Actuales',
    
    additionalInfo: 'Información Adicional',
    doctorName: 'Nombre del Doctor',
    doctorPhone: 'Teléfono del Doctor',
    preferredHospital: 'Hospital Preferido',
    organDonor: 'Donante de Órganos',
    registeredDonor: 'Donante registrado',
    specialInstructions: 'Instrucciones Especiales',
    specialInstructionsPlaceholder: 'Deseos DNR, preferencias religiosas, etc.',
    
    createCard: 'Crear Tarjeta de Emergencia',
    saveToPhone: 'Guardar QR en Teléfono',
    shareCode: 'Compartir Código QR',
    copyKey: 'Copiar Clave',
    previewCard: 'Ver Tarjeta',
    
    cardCreated: '¡Tarjeta Creada!',
    saveInstructions: 'Guarda este QR en tu teléfono. En emergencias, muéstralo al personal médico.',
    iphoneHint: 'En iPhone: Mantén presionada la imagen → "Agregar a Fotos"',
    saveEditKey: '¡Guarda Tu Clave de Edición!',
    editKeyHint: 'La necesitarás para actualizar tu tarjeta después.',
    
    emergencyMedicalInfo: 'INFO MÉDICA DE EMERGENCIA',
    call: 'Llamar',
    medicalProvider: 'Proveedor Médico',
    lastUpdated: 'Última actualización',
    securedBy: 'Protegido por Emergency Card',
    
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
  },
  
  fr: {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    
    appName: 'Carte d\'Urgence',
    tagline: 'Vos informations médicales, toujours accessibles',
    price: '1€',
    oneTime: 'unique',
    
    heroTitle: 'Sauvez une Vie. La Vôtre.',
    heroSubtitle: 'Créez une carte médicale d\'urgence que n\'importe qui peut scanner.',
    getStarted: 'Créer Votre Carte - 1€',
    
    feature1Title: 'Accès Instantané',
    feature1Desc: 'Le code QR affiche vos infos instantanément',
    feature2Title: 'Pas d\'App Nécessaire',
    feature2Desc: 'N\'importe qui peut scanner avec son téléphone',
    feature3Title: 'Toujours Disponible',
    feature3Desc: 'Enregistrez sur votre téléphone, fonctionne hors ligne',
    
    basicInfo: 'Informations de Base',
    fullName: 'Nom Complet',
    fullNamePlaceholder: 'Comme sur votre pièce d\'identité',
    dateOfBirth: 'Date de Naissance',
    bloodGroup: 'Groupe Sanguin',
    gender: 'Genre',
    male: 'Homme',
    female: 'Femme',
    other: 'Autre',
    
    emergencyContacts: 'Contacts d\'Urgence',
    contactName: 'Nom',
    relationship: 'Relation',
    phone: 'Téléphone',
    primary: 'Principal',
    addContact: 'Ajouter Contact',
    spouse: 'Conjoint(e)',
    parent: 'Parent',
    child: 'Enfant',
    sibling: 'Frère/Sœur',
    friend: 'Ami(e)',
    doctor: 'Médecin',
    
    allergies: 'Allergies',
    allergiesSubtitle: 'Allergies médicamenteuses et alimentaires',
    severe: 'Sévère',
    moderate: 'Modérée',
    mild: 'Légère',
    lifeThreatening: 'Potentiellement mortel',
    significantReaction: 'Réaction significative',
    minorReaction: 'Réaction mineure',
    typeToSearch: 'Tapez 3+ lettres pour chercher...',
    
    medicalConditions: 'Conditions Médicales',
    currentMedications: 'Médicaments Actuels',
    
    additionalInfo: 'Informations Supplémentaires',
    doctorName: 'Nom du Médecin',
    doctorPhone: 'Téléphone du Médecin',
    preferredHospital: 'Hôpital Préféré',
    organDonor: 'Donneur d\'Organes',
    registeredDonor: 'Donneur enregistré',
    specialInstructions: 'Instructions Spéciales',
    specialInstructionsPlaceholder: 'Souhaits DNR, préférences religieuses, etc.',
    
    createCard: 'Créer Carte d\'Urgence',
    saveToPhone: 'Enregistrer QR sur Téléphone',
    shareCode: 'Partager Code QR',
    copyKey: 'Copier Clé',
    previewCard: 'Aperçu Carte',
    
    cardCreated: 'Carte Créée!',
    saveInstructions: 'Enregistrez ce QR sur votre téléphone. En urgence, montrez-le au personnel médical.',
    iphoneHint: 'Sur iPhone: Appuyez longuement → "Ajouter aux Photos"',
    saveEditKey: 'Sauvegardez Votre Clé!',
    editKeyHint: 'Nécessaire pour mettre à jour votre carte plus tard.',
    
    emergencyMedicalInfo: 'INFO MÉDICALE D\'URGENCE',
    call: 'Appeler',
    medicalProvider: 'Prestataire Médical',
    lastUpdated: 'Dernière mise à jour',
    securedBy: 'Sécurisé par Emergency Card',
    
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
  },
  
  de: {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
    
    appName: 'Notfallkarte',
    tagline: 'Ihre medizinischen Daten, immer zugänglich',
    price: '1€',
    oneTime: 'einmalig',
    
    heroTitle: 'Retten Sie ein Leben. Ihres.',
    heroSubtitle: 'Erstellen Sie eine medizinische Notfallkarte, die jeder scannen kann.',
    getStarted: 'Karte Erstellen - 1€',
    
    feature1Title: 'Sofortiger Zugriff',
    feature1Desc: 'QR-Code zeigt Ihre Infos sofort an',
    feature2Title: 'Keine App Nötig',
    feature2Desc: 'Jeder kann mit dem Handy scannen',
    feature3Title: 'Immer Verfügbar',
    feature3Desc: 'Auf dem Handy speichern, funktioniert offline',
    
    basicInfo: 'Grundinformationen',
    fullName: 'Vollständiger Name',
    fullNamePlaceholder: 'Wie auf dem Ausweis',
    dateOfBirth: 'Geburtsdatum',
    bloodGroup: 'Blutgruppe',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Divers',
    
    emergencyContacts: 'Notfallkontakte',
    contactName: 'Name',
    relationship: 'Beziehung',
    phone: 'Telefon',
    primary: 'Haupt',
    addContact: 'Kontakt Hinzufügen',
    spouse: 'Ehepartner',
    parent: 'Elternteil',
    child: 'Kind',
    sibling: 'Geschwister',
    friend: 'Freund/in',
    doctor: 'Arzt',
    
    allergies: 'Allergien',
    allergiesSubtitle: 'Medikamenten- und Nahrungsmittelallergien',
    severe: 'Schwer',
    moderate: 'Mittel',
    mild: 'Leicht',
    lifeThreatening: 'Lebensbedrohlich',
    significantReaction: 'Erhebliche Reaktion',
    minorReaction: 'Geringe Reaktion',
    typeToSearch: '3+ Buchstaben zum Suchen eingeben...',
    
    medicalConditions: 'Erkrankungen',
    currentMedications: 'Aktuelle Medikamente',
    
    additionalInfo: 'Zusätzliche Informationen',
    doctorName: 'Name des Arztes',
    doctorPhone: 'Telefon des Arztes',
    preferredHospital: 'Bevorzugtes Krankenhaus',
    organDonor: 'Organspender',
    registeredDonor: 'Registrierter Spender',
    specialInstructions: 'Besondere Anweisungen',
    specialInstructionsPlaceholder: 'DNR-Wünsche, religiöse Präferenzen, etc.',
    
    createCard: 'Notfallkarte Erstellen',
    saveToPhone: 'QR auf Handy Speichern',
    shareCode: 'QR-Code Teilen',
    copyKey: 'Schlüssel Kopieren',
    previewCard: 'Karte Ansehen',
    
    cardCreated: 'Karte Erstellt!',
    saveInstructions: 'Speichern Sie diesen QR auf Ihrem Handy. Im Notfall dem Personal zeigen.',
    iphoneHint: 'Auf iPhone: Lange drücken → "Zu Fotos hinzufügen"',
    saveEditKey: 'Speichern Sie Ihren Schlüssel!',
    editKeyHint: 'Benötigt für spätere Aktualisierungen.',
    
    emergencyMedicalInfo: 'MEDIZINISCHE NOTFALLDATEN',
    call: 'Anrufen',
    medicalProvider: 'Medizinischer Anbieter',
    lastUpdated: 'Zuletzt aktualisiert',
    securedBy: 'Gesichert durch Emergency Card',
    
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
  },
  
  zh: {
    code: 'zh',
    name: '中文',
    flag: '🇨🇳',
    
    appName: '急救卡',
    tagline: '您的医疗信息，随时可用',
    price: '$1',
    oneTime: '一次性',
    
    heroTitle: '拯救生命。您的生命。',
    heroSubtitle: '创建一张任何人都可以扫描的急救医疗卡。',
    getStarted: '创建您的卡片 - $1',
    
    feature1Title: '即时访问',
    feature1Desc: '二维码立即显示您的信息',
    feature2Title: '无需应用',
    feature2Desc: '任何人都可以用手机摄像头扫描',
    feature3Title: '始终可用',
    feature3Desc: '保存到手机，离线可用',
    
    basicInfo: '基本信息',
    fullName: '姓名',
    fullNamePlaceholder: '与身份证一致',
    dateOfBirth: '出生日期',
    bloodGroup: '血型',
    gender: '性别',
    male: '男',
    female: '女',
    other: '其他',
    
    emergencyContacts: '紧急联系人',
    contactName: '姓名',
    relationship: '关系',
    phone: '电话',
    primary: '主要',
    addContact: '添加联系人',
    spouse: '配偶',
    parent: '父母',
    child: '子女',
    sibling: '兄弟姐妹',
    friend: '朋友',
    doctor: '医生',
    
    allergies: '过敏',
    allergiesSubtitle: '药物和食物过敏',
    severe: '严重',
    moderate: '中度',
    mild: '轻度',
    lifeThreatening: '危及生命',
    significantReaction: '明显反应',
    minorReaction: '轻微反应',
    typeToSearch: '输入3个以上字符搜索...',
    
    medicalConditions: '疾病状况',
    currentMedications: '当前用药',
    
    additionalInfo: '其他信息',
    doctorName: '医生姓名',
    doctorPhone: '医生电话',
    preferredHospital: '首选医院',
    organDonor: '器官捐献者',
    registeredDonor: '已注册捐献者',
    specialInstructions: '特殊说明',
    specialInstructionsPlaceholder: 'DNR意愿、宗教偏好等',
    
    createCard: '创建急救卡',
    saveToPhone: '保存二维码到手机',
    shareCode: '分享二维码',
    copyKey: '复制密钥',
    previewCard: '预览卡片',
    
    cardCreated: '卡片已创建！',
    saveInstructions: '将此二维码保存到手机。紧急情况下出示给医护人员。',
    iphoneHint: 'iPhone：长按图片 → "添加到照片"',
    saveEditKey: '保存您的编辑密钥！',
    editKeyHint: '以后更新卡片时需要。',
    
    emergencyMedicalInfo: '紧急医疗信息',
    call: '呼叫',
    medicalProvider: '医疗服务提供者',
    lastUpdated: '最后更新',
    securedBy: '由 Emergency Card 保护',
    
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
  },
  
  ja: {
    code: 'ja',
    name: '日本語',
    flag: '🇯🇵',
    
    appName: '緊急カード',
    tagline: 'あなたの医療情報、いつでもアクセス可能',
    price: '$1',
    oneTime: '一回限り',
    
    heroTitle: '命を救う。あなたの命を。',
    heroSubtitle: '誰でもスキャンできる緊急医療カードを作成。',
    getStarted: 'カードを作成 - $1',
    
    feature1Title: '即座にアクセス',
    feature1Desc: 'QRコードで情報を即座に表示',
    feature2Title: 'アプリ不要',
    feature2Desc: '誰でもスマホのカメラでスキャン可能',
    feature3Title: 'いつでも利用可能',
    feature3Desc: 'スマホに保存、オフラインで動作',
    
    basicInfo: '基本情報',
    fullName: '氏名',
    fullNamePlaceholder: '身分証明書と同じ',
    dateOfBirth: '生年月日',
    bloodGroup: '血液型',
    gender: '性別',
    male: '男性',
    female: '女性',
    other: 'その他',
    
    emergencyContacts: '緊急連絡先',
    contactName: '名前',
    relationship: '関係',
    phone: '電話',
    primary: '主要',
    addContact: '連絡先を追加',
    spouse: '配偶者',
    parent: '親',
    child: '子供',
    sibling: '兄弟姉妹',
    friend: '友人',
    doctor: '医師',
    
    allergies: 'アレルギー',
    allergiesSubtitle: '薬物・食物アレルギー',
    severe: '重度',
    moderate: '中度',
    mild: '軽度',
    lifeThreatening: '生命を脅かす',
    significantReaction: '重大な反応',
    minorReaction: '軽微な反応',
    typeToSearch: '3文字以上入力して検索...',
    
    medicalConditions: '疾患',
    currentMedications: '現在の服薬',
    
    additionalInfo: '追加情報',
    doctorName: '医師名',
    doctorPhone: '医師の電話',
    preferredHospital: '希望病院',
    organDonor: '臓器提供者',
    registeredDonor: '登録済み提供者',
    specialInstructions: '特別な指示',
    specialInstructionsPlaceholder: 'DNRの希望、宗教上の配慮など',
    
    createCard: '緊急カードを作成',
    saveToPhone: 'QRをスマホに保存',
    shareCode: 'QRコードを共有',
    copyKey: 'キーをコピー',
    previewCard: 'カードをプレビュー',
    
    cardCreated: 'カード作成完了！',
    saveInstructions: 'このQRをスマホに保存。緊急時に医療スタッフに見せてください。',
    iphoneHint: 'iPhoneの場合：画像を長押し→「写真に追加」',
    saveEditKey: '編集キーを保存！',
    editKeyHint: 'カードを更新する際に必要です。',
    
    emergencyMedicalInfo: '緊急医療情報',
    call: '電話',
    medicalProvider: '医療提供者',
    lastUpdated: '最終更新',
    securedBy: 'Emergency Card により保護',
    
    privacyPolicy: 'プライバシーポリシー',
    termsOfService: '利用規約',
  },
  
  ar: {
    code: 'ar',
    name: 'العربية',
    flag: '🇸🇦',
    direction: 'rtl',
    
    appName: 'بطاقة الطوارئ',
    tagline: 'معلوماتك الطبية، متاحة دائماً',
    price: '$1',
    oneTime: 'مرة واحدة',
    
    heroTitle: 'أنقذ حياة. حياتك.',
    heroSubtitle: 'أنشئ بطاقة طوارئ طبية يمكن لأي شخص مسحها.',
    getStarted: 'أنشئ بطاقتك - $1',
    
    feature1Title: 'وصول فوري',
    feature1Desc: 'رمز QR يعرض معلوماتك فوراً',
    feature2Title: 'لا حاجة لتطبيق',
    feature2Desc: 'أي شخص يمكنه المسح بكاميرا هاتفه',
    feature3Title: 'متاح دائماً',
    feature3Desc: 'احفظه على هاتفك، يعمل بدون إنترنت',
    
    basicInfo: 'المعلومات الأساسية',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'كما في بطاقة الهوية',
    dateOfBirth: 'تاريخ الميلاد',
    bloodGroup: 'فصيلة الدم',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    other: 'آخر',
    
    emergencyContacts: 'جهات اتصال الطوارئ',
    contactName: 'الاسم',
    relationship: 'العلاقة',
    phone: 'الهاتف',
    primary: 'رئيسي',
    addContact: 'إضافة جهة اتصال',
    spouse: 'الزوج/ة',
    parent: 'الوالد/ة',
    child: 'الابن/ة',
    sibling: 'الأخ/ت',
    friend: 'صديق/ة',
    doctor: 'طبيب',
    
    allergies: 'الحساسية',
    allergiesSubtitle: 'حساسية الأدوية والطعام',
    severe: 'شديدة',
    moderate: 'متوسطة',
    mild: 'خفيفة',
    lifeThreatening: 'مهددة للحياة',
    significantReaction: 'رد فعل كبير',
    minorReaction: 'رد فعل طفيف',
    typeToSearch: 'اكتب 3+ أحرف للبحث...',
    
    medicalConditions: 'الحالات الطبية',
    currentMedications: 'الأدوية الحالية',
    
    additionalInfo: 'معلومات إضافية',
    doctorName: 'اسم الطبيب',
    doctorPhone: 'هاتف الطبيب',
    preferredHospital: 'المستشفى المفضل',
    organDonor: 'متبرع بالأعضاء',
    registeredDonor: 'متبرع مسجل',
    specialInstructions: 'تعليمات خاصة',
    specialInstructionsPlaceholder: 'رغبات DNR، التفضيلات الدينية، إلخ.',
    
    createCard: 'إنشاء بطاقة الطوارئ',
    saveToPhone: 'حفظ QR على الهاتف',
    shareCode: 'مشاركة رمز QR',
    copyKey: 'نسخ المفتاح',
    previewCard: 'معاينة البطاقة',
    
    cardCreated: 'تم إنشاء البطاقة!',
    saveInstructions: 'احفظ هذا QR على هاتفك. في حالات الطوارئ، أظهره للطاقم الطبي.',
    iphoneHint: 'على iPhone: اضغط طويلاً على الصورة ← "إضافة إلى الصور"',
    saveEditKey: 'احفظ مفتاح التحرير!',
    editKeyHint: 'ستحتاجه لتحديث بطاقتك لاحقاً.',
    
    emergencyMedicalInfo: 'معلومات طوارئ طبية',
    call: 'اتصال',
    medicalProvider: 'مقدم الرعاية الطبية',
    lastUpdated: 'آخر تحديث',
    securedBy: 'محمي بواسطة Emergency Card',
    
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
  },
  
  pt: {
    code: 'pt',
    name: 'Português',
    flag: '🇧🇷',
    
    appName: 'Cartão de Emergência',
    tagline: 'Suas informações médicas, sempre acessíveis',
    price: '$1',
    oneTime: 'único',
    
    heroTitle: 'Salve uma Vida. A Sua.',
    heroSubtitle: 'Crie um cartão médico de emergência que qualquer um pode escanear.',
    getStarted: 'Criar Seu Cartão - $1',
    
    feature1Title: 'Acesso Instantâneo',
    feature1Desc: 'QR code mostra suas informações instantaneamente',
    feature2Title: 'Sem App Necessário',
    feature2Desc: 'Qualquer um pode escanear com a câmera do celular',
    feature3Title: 'Sempre Disponível',
    feature3Desc: 'Salve no celular, funciona offline',
    
    basicInfo: 'Informações Básicas',
    fullName: 'Nome Completo',
    fullNamePlaceholder: 'Como na identidade',
    dateOfBirth: 'Data de Nascimento',
    bloodGroup: 'Tipo Sanguíneo',
    gender: 'Gênero',
    male: 'Masculino',
    female: 'Feminino',
    other: 'Outro',
    
    emergencyContacts: 'Contatos de Emergência',
    contactName: 'Nome',
    relationship: 'Relacionamento',
    phone: 'Telefone',
    primary: 'Principal',
    addContact: 'Adicionar Contato',
    spouse: 'Cônjuge',
    parent: 'Pai/Mãe',
    child: 'Filho/a',
    sibling: 'Irmão/ã',
    friend: 'Amigo/a',
    doctor: 'Médico',
    
    allergies: 'Alergias',
    allergiesSubtitle: 'Alergias a medicamentos e alimentos',
    severe: 'Grave',
    moderate: 'Moderada',
    mild: 'Leve',
    lifeThreatening: 'Risco de vida',
    significantReaction: 'Reação significativa',
    minorReaction: 'Reação menor',
    typeToSearch: 'Digite 3+ letras para buscar...',
    
    medicalConditions: 'Condições Médicas',
    currentMedications: 'Medicamentos Atuais',
    
    additionalInfo: 'Informações Adicionais',
    doctorName: 'Nome do Médico',
    doctorPhone: 'Telefone do Médico',
    preferredHospital: 'Hospital Preferido',
    organDonor: 'Doador de Órgãos',
    registeredDonor: 'Doador registrado',
    specialInstructions: 'Instruções Especiais',
    specialInstructionsPlaceholder: 'Desejos DNR, preferências religiosas, etc.',
    
    createCard: 'Criar Cartão de Emergência',
    saveToPhone: 'Salvar QR no Celular',
    shareCode: 'Compartilhar QR Code',
    copyKey: 'Copiar Chave',
    previewCard: 'Visualizar Cartão',
    
    cardCreated: 'Cartão Criado!',
    saveInstructions: 'Salve este QR no seu celular. Em emergências, mostre à equipe médica.',
    iphoneHint: 'No iPhone: Pressione a imagem → "Adicionar às Fotos"',
    saveEditKey: 'Salve Sua Chave de Edição!',
    editKeyHint: 'Necessária para atualizar seu cartão depois.',
    
    emergencyMedicalInfo: 'INFO MÉDICA DE EMERGÊNCIA',
    call: 'Ligar',
    medicalProvider: 'Provedor Médico',
    lastUpdated: 'Última atualização',
    securedBy: 'Protegido por Emergency Card',
    
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
  },
  
  ru: {
    code: 'ru',
    name: 'Русский',
    flag: '🇷🇺',
    
    appName: 'Карта Экстренной Помощи',
    tagline: 'Ваша медицинская информация всегда доступна',
    price: '$1',
    oneTime: 'единоразово',
    
    heroTitle: 'Спасите Жизнь. Свою.',
    heroSubtitle: 'Создайте экстренную медицинскую карту, которую может сканировать любой.',
    getStarted: 'Создать Карту - $1',
    
    feature1Title: 'Мгновенный Доступ',
    feature1Desc: 'QR-код мгновенно показывает вашу информацию',
    feature2Title: 'Приложение Не Нужно',
    feature2Desc: 'Любой может сканировать камерой телефона',
    feature3Title: 'Всегда Доступно',
    feature3Desc: 'Сохраните на телефон, работает офлайн',
    
    basicInfo: 'Основная Информация',
    fullName: 'Полное Имя',
    fullNamePlaceholder: 'Как в документе',
    dateOfBirth: 'Дата Рождения',
    bloodGroup: 'Группа Крови',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    other: 'Другой',
    
    emergencyContacts: 'Экстренные Контакты',
    contactName: 'Имя',
    relationship: 'Отношение',
    phone: 'Телефон',
    primary: 'Основной',
    addContact: 'Добавить Контакт',
    spouse: 'Супруг/а',
    parent: 'Родитель',
    child: 'Ребенок',
    sibling: 'Брат/Сестра',
    friend: 'Друг',
    doctor: 'Врач',
    
    allergies: 'Аллергии',
    allergiesSubtitle: 'Лекарственные и пищевые аллергии',
    severe: 'Тяжелая',
    moderate: 'Умеренная',
    mild: 'Легкая',
    lifeThreatening: 'Опасно для жизни',
    significantReaction: 'Значительная реакция',
    minorReaction: 'Незначительная реакция',
    typeToSearch: 'Введите 3+ буквы для поиска...',
    
    medicalConditions: 'Заболевания',
    currentMedications: 'Текущие Лекарства',
    
    additionalInfo: 'Дополнительная Информация',
    doctorName: 'Имя Врача',
    doctorPhone: 'Телефон Врача',
    preferredHospital: 'Предпочтительная Больница',
    organDonor: 'Донор Органов',
    registeredDonor: 'Зарегистрированный донор',
    specialInstructions: 'Особые Указания',
    specialInstructionsPlaceholder: 'DNR пожелания, религиозные предпочтения и т.д.',
    
    createCard: 'Создать Карту',
    saveToPhone: 'Сохранить QR на Телефон',
    shareCode: 'Поделиться QR',
    copyKey: 'Копировать Ключ',
    previewCard: 'Просмотр Карты',
    
    cardCreated: 'Карта Создана!',
    saveInstructions: 'Сохраните этот QR на телефон. В экстренных случаях покажите медперсоналу.',
    iphoneHint: 'На iPhone: Удерживайте изображение → «Добавить в Фото»',
    saveEditKey: 'Сохраните Ключ Редактирования!',
    editKeyHint: 'Понадобится для обновления карты позже.',
    
    emergencyMedicalInfo: 'ЭКСТРЕННАЯ МЕДИЦИНСКАЯ ИНФОРМАЦИЯ',
    call: 'Позвонить',
    medicalProvider: 'Медицинский Провайдер',
    lastUpdated: 'Последнее обновление',
    securedBy: 'Защищено Emergency Card',
    
    privacyPolicy: 'Политика Конфиденциальности',
    termsOfService: 'Условия Использования',
  },
};

export const getTranslation = (lang) => {
  return translations[lang] || translations.en;
};

export const supportedLanguages = Object.keys(translations).map(key => ({
  code: key,
  name: translations[key].name,
  flag: translations[key].flag,
}));
